














































import { Component, Vue, Prop, Watch } from "vue-property-decorator";

import BSwitch from "@/components/app/switchs/b-switch.vue";
import StandartModal from "@/components/app/standart-modal.vue";
import draggable from "vuedraggable";

@Component({ components: { StandartModal, draggable, BSwitch } })
export default class OnlineNavigationConfiguration extends Vue {
  @Prop({ type: Array, default: () => [] }) nav!: Array<string>;
  dragging = false;
  enabled = true;
  show = false;

  defautl_list = ["MapPage", "OfflineMap", "CamerasPage"];
  navList: Array<string> = [];

  getChecked(id: string): boolean {
    return this.navList.includes(id);
  }

  changeSource(id: string): void {
    const i = this.navList.findIndex((el) => el == id);
    if (i < 0) this.navList.push(id);
    else this.navList.splice(i, 1);
  }

  @Watch("sources", { deep: true })
  updateNavList(): void {
    this.navList = this.nav ? this.nav : [];
    this.show = true;
  }

  mounted(): void {
    this.$nextTick(() => this.updateNavList());
  }
}
